import React,{forwardRef,useEffect,useImperativeHandle} from "react";
import OrderReview from "../OrderReview/OrderReview"

const ReviewOrder = forwardRef((props,ref)=>{
    useImperativeHandle(ref, () => ({

        proceed() { 
            //validation code
          return new Promise((resolve,reject)=>{
              resolve(true)
          })
        }   
    
      }));
      useEffect(()=>{
        props.setVisibility(false); 

      },[])
     
      return( 
          <div>
              
             <OrderReview setStep={props.setStep}/>
          </div>
      )
})



export default  ReviewOrder